var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"box-style"},[_vm._t("default",null,{"isOpen":_setup.isOpen,"toggle":_setup.toggle})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }